import store from "@/store";
import isMobile from "@/functions/deviceDetection";

export function utagDataPost(to) {
    const utagData = {
        tealium_event: "view",
        page_name: `goal-rush:${to.path.substring(1, to.path.length)}`,
        page_section: `goal-rush:${to.path.substring(1, to.path.length)}`,
        page_parent_domain: window.origin,
        page_country: "south africa",
        page_url: `${window.origin}${to.fullPath}`,
        page_locale: "za",
        page_title: document.title,
        page_platform: isMobile() ? 'web-mobile' : 'web-desktop',
        visitor_id_asset_active: `${store.state.user?.subscriptionId}`,
        visitor_login_status: store.state.user ? `loggedin` : `loggedout`,
        site_version: "1.0",
        site_type: "web"
    };

    if (utag) utag.view(utagData);
}
